module.exports = __webpack_public_path__ + "static/media/whiteFrame.20b5b21d.png";